<h3 class="mt-3 d-flex align-items-center gap-3">
    Meeting templates
    <button class="ms-auto"
            adaptButton="addLink"
            [adaptBlockingClick]="addNewAgendaTemplate"
            data-test="add-agenda-template">Add {{!team ? "organisation" : "team"}} template
    </button>
</h3>
<ng-container *adaptLoading="loadingTemplates">
    <dx-list [dataSource]="dataSource"
             [hoverStateEnabled]="false"
             [focusStateEnabled]="false"
             [activeStateEnabled]="false"
             [searchEnabled]="!team"
             [searchExpr]="searchTemplateFunction"
             [grouped]="true"
             selectionMode="none"
             noDataText="There are no meeting templates defined"
             (onInitialized)="onListInitialized($event)"
             [collapsibleGroups]="true">
        <div *dxTemplate="let agenda of 'item'"
             class="d-flex px-0">
            <div class="align-self-center mb-0">
                <adapt-display-agenda-name [agendaDetail]="agenda"
                                           [id]="'agenda-name-' + agenda.meetingTemplate.meetingAgendaTemplateId"
                                           (agendaClicked)="editAgendaTemplate(agenda.meetingTemplate).subscribe()"></adapt-display-agenda-name>
            </div>
            <div class="ms-auto d-flex align-self-center align-items-center">
                <button [adaptButton]="agenda.meetingTemplate.code ? 'viewBorderless' : 'editBorderless'"
                        [adaptTooltip]="agenda.meetingTemplate.code ? 'This is a system-defined template that cannot be edited or deleted.' : 'Edit meeting template'"
                        [adaptBlockingClick]="editAgendaTemplate"
                        [adaptBlockingClickParam]="agenda.meetingTemplate"
                        data-test="edit-agenda-template-item"></button>
                <button adaptButton="copyBorderless"
                        adaptTooltip="Copy meeting template"
                        [adaptBlockingClick]="copyMeetingTemplate"
                        [adaptBlockingClickParam]="agenda.meetingTemplate"
                        data-test="copy-agenda-template-item"></button>
                <button adaptButton="moveBorderless"
                        adaptTooltip="Move meeting template"
                        [adaptBlockingClick]="moveMeetingTemplate"
                        [attr.disabled]="(!canMove || agenda.meetingTemplate.code) ? true : undefined"
                        [adaptBlockingClickParam]="agenda.meetingTemplate"
                        data-test="move-agenda-template-item"></button>
                <button class="ms-2"
                        adaptButton="deleteBorderless"
                        adaptTooltip="Delete meeting template"
                        [attr.disabled]="agenda.meetingTemplate.code ? true : undefined"
                        [adaptBlockingClick]="deleteAgendaTemplate"
                        [adaptBlockingClickParam]="agenda.meetingTemplate"
                        data-test="delete-agenda-template-item"></button>
            </div>
        </div>
        <div *dxTemplate="let group of 'group'"
             class="d-flex gap-2 align-items-center"
             (click)="gotoTeamConfigurationPage(group)">
            @if (group.key.startsWith('000000 ')) {
                <i class="fal fa-cubes"></i>
                {{group.key.substring(7)}}
            } @else {
                <i class="fal fa-users"></i>
                {{group.key}}
            }
        </div>
    </dx-list>
</ng-container>

@if (team) {
    <button *adaptIfAuthorised="CanConfigureOrganisation"
            class="mt-3"
            adaptButton="configureLink"
            (click)="gotoOrganisationConfigurationPage()">Configure organisation templates
    </button>
}
